import { Button } from "@blueprintjs/core";
import { ButtonContainer, IDataTableColumn, useGridState, useSearchApi } from "nsitools-react";
import * as React from "react";

import {
  DogAvailableOwnersApi,
  DogBaseSearch,
  PeopleReferentialItem,
  PersonGridDto,
  ReferentialApi,
  SearchPeopleReferentialQuery,
} from "../../../../../../api";
import { CustomDataTable, EmailButton } from "../../../../../../components";
import { useGlobalData } from "../../../../../../contexts";
import { useApiService, useTl } from "../../../../../../hooks";
import { ETLCodes } from "../../../../../../locales";
import { generateAddress } from "../../../../../../utils";

export interface IOwnerSearchPanelProps {
  onPersonSelected: (person: PersonGridDto) => void;
  dogId: number;
}

export const OwnerSearchPanel: React.FunctionComponent<IOwnerSearchPanelProps> = (props) => {
  const api = useApiService(DogAvailableOwnersApi);
  const refApi = useApiService(ReferentialApi);
  const { currentLanguage } = useGlobalData();
  const { t } = useTl();

  const tableState = useGridState<any>({
    serverMode: true,
    enablePagination: true,
    enableFilter: true,
    availablePageSizes: [5],
    pageSize: 5,
    sortKeys: { lastName: "ASC" },
  });

  const searchFunction = React.useCallback(
    (sObj?: DogBaseSearch) => refApi.searchPeople(SearchPeopleReferentialQuery.fromJS({ sObj })),
    [refApi]
  );

  const { search, loading } = useSearchApi<any, any>({
    searchFunction,
    tableState,
    initialSearch: true,
    trimSearchObjectStringValues: true,
  });

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        header: () => t(ETLCodes.Name),
        fieldName: "computedName",
        render: (row: PeopleReferentialItem) => row.computedName,
      },
      {
        fieldName: "email",
        header: () => t(ETLCodes.Email),
        render: (row: PeopleReferentialItem) => <EmailButton email={row.email} />,
      },
      {
        fieldName: "address",
        computed: true,
        disableSorting: true,
        header: () => t(ETLCodes.Address),
        render: (row: PeopleReferentialItem) => (
          <div> {generateAddress(row.number, row.street, row.city, row.postalCode, row.country)}</div>
        ),
      },
    ],
    [t]
  );
  React.useEffect(() => {
    search();
  }, [currentLanguage, search]);
  return (
    <CustomDataTable
      tableState={tableState}
      loading={loading}
      columns={columns}
      filterMode="OnEnter"
      focusOnFilter={true}
      onRowClick={(row) => props.onPersonSelected(row)}
    />
  );
};
